﻿import {Core} from "../../Base/Core";
import {NUtils} from "../../Utils/NUtils";
import {GameManager} from "../../Game/GameManager";
import {MoneyType, UpgradeType} from "../../enums";
import {UISprite} from "../Tools/Base/UISprite";
import {UIText} from "../Tools/Base/UIText";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {RewardedAdsBtn} from "../RewardedAdsBtn";

export class UIMoneyBox extends UICommonPopup {
    get moneyPerSecond() {
        return (GameManager.gameController && GameManager.gameController.MoneySoftSpeed) || 0;
    }

    get storedSeconds() {
        let moneyBoxUpgradeProgress = Core.Player.PlanetsSave.GetUpgradeProgress(UpgradeType.MoneyBox);
        let upgradeIndex = moneyBoxUpgradeProgress.upgradeIndex;
        return Core.GameData.Upgrades.UpgradeByType(UpgradeType.MoneyBox).TotalValue(upgradeIndex);
    }

    get seconds() {
        let timeLeftFromLastLogin = ~~((Core.Time.serverTime - Core.Player.Timers.lastActionTime) / 1000);
        return Math.max(0, Math.min(timeLeftFromLastLogin, this.storedSeconds));
    }

    get totalMoney() {
        let res = BigInt(this.moneyPerSecond) * BigInt(this.seconds);
        let k = this.seconds >= Core.GameData.WelcomeBack.MinSecondsToFire
            ? BigInt(Core.GameData.WelcomeBack.MoneyBoxMultiplayer)
            : 1n
        ;
        return res * k;
    }

    Awake() {
        super.Awake();

        this.onClickTake = this.onClickTake.bind(this);
        this.onClickTakeX2 = this.onClickTakeX2.bind(this);
        this.onShown = this.onShown.bind(this);

        this.iconImg = this.content.addChild(new UISprite("pig"));

        this.descriptionField = this.content.addChild(new UIText(Core.Localizator.Get("money_box_reward")));

        this.totalRewardField = this.content.addChild(
            new UILabeledIcon({
                label: "",
                icon: "",
                iconAlign: "left",
                iconSize: 0.6,
                textProps: { fontSize: 80 },
            })
        );

        this.takeBtn = this.content.addChild(
            new UINineSliceButton("btn-blue", {
                label: Core.Localizator.Get("take"),
            })
        );

        this.takeX2Btn = this.content.addChild(
            new RewardedAdsBtn("btn-green", {
                icon: "play-icon",
                iconAlign: "left",
                label: Core.Localizator.Get("take_double"),
            })
        );

        this.moneyType = MoneyType.Soft;

        this.takeBtn.on("pointertap", this.onClickTake);
        this.takeX2Btn.on("pointertap", this.onClickTakeX2);
    }

    Init() {
        super.Init();
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.4;
        let w = Math.min(viewport.width * 0.6, (viewport.height * 0.6) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.45;
        rect.width = popupRect.width * 0.7;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0;
        this.iconImg.fitRect(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.15;
        rect.width = popupRect.width * 0.86;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.51;
        this.descriptionField.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.8;
        rect.height = popupRect.height * 0.2;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.72;
        this.totalRewardField.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.41;
        rect.height = popupRect.height * 0.16;
        rect.x = (popupRect.width - rect.width) * 0.11;
        rect.y = (popupRect.height - rect.height) * 0.95;
        this.takeBtn.fitLayout(rect);

        rect.x = (popupRect.width - rect.width) * 0.89;
        this.takeX2Btn.fitLayout(rect);
    }

    Show() {
        this.updateUI();
        super.Show();
    }

    onClickTakeX2() {
        Core.Ads.TriggerRewarded(this.onShown);
    }

    onShown() {
        this.Take(this.totalMoney * 2n);
    }

    onClickTake() {
        this.Take(this.totalMoney);
    }

    Take(value = this.totalMoney) {
        console.log("TAKE BOX", value, this.seconds);
        Core.Player.Timers.lastActionTime = Core.Time.serverTime;
        Core.Player.AddMoney(this.moneyType, value);
        this.Hide();
    }

    updateUI() {
        switch (this.moneyType) {
            case MoneyType.Soft:
                this.totalRewardField.icon = "ico-gold";
                break;
            case MoneyType.Hard:
                this.totalRewardField.icon = "ico-diamond";
                break;
            default:
                this.totalRewardField.icon = "";
                break;
        }
        this.totalRewardField.label = NUtils.FormatMoney(this.totalMoney);
    }

    Check() {
        if (!Core.Time.Initialized || !Core.Player.Initialized) return;
        if (!Core.Player.PlanetsSave.GetUpgradeProgress(UpgradeType.MoneyBox).upgradeIndex) return;
        if (Core.Player.Timers.lastActionTime > 0) {
            if (this.totalMoney > 0 && this.seconds > 300) {
                this.Show();
            }
        }
    }
}
